import { render, staticRenderFns } from "./AscPageComingSoon.vue?vue&type=template&id=2e8bde0c&"
import script from "./AscPageComingSoon.vue?vue&type=script&lang=js&"
export * from "./AscPageComingSoon.vue?vue&type=script&lang=js&"
import style0 from "./AscPageComingSoon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports